import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "ant-layout-footer",
  style: {"margin-top":"30px","position":"static","bottom":"0px"},
  id: "foor"
}
const _hoisted_2 = {
  style: {"color":"#0000004d!important","text-align":"center"},
  class: "text-black/30"
}

import brand from '@/config/brand'

export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, " Copyright © " + _toDisplayString(new Date().getFullYear()) + " " + _toDisplayString(_unref(brand).copyrightName) + " 保留所有权利 ", 1),
      _cache[0] || (_cache[0] = _createElementVNode("a", {
        class: "ant-btn",
        target: "_blank",
        rel: "noreferrer",
        href: "https://beian.miit.gov.cn/#/Integrated/index"
      }, "京ICP备14059360号-17", -1))
    ])
  ]))
}
}

})